const swiperTestimonial = new Swiper(
  ".testimonial-slides .swiper-testimonial",
  {
    autoplay: { delay: 5000 },
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-testimonials",
      prevEl: ".swiper-button-prev-testimonials",
    },
    pagination: {
      el: ".swiper-pagination-testimonials",
    },
  }
);
